// Lista de partes da aba com liga/desliga (Ajustes › Abas e a pergunta da primeira vez). 0.65, Texto 3 D.
import { Pressable, Text, View } from 'react-native';
import type { ModId } from '../store/types';
import { DEFS } from '../modulos/defs';
import { mudarParte, partesDaAba, usePartes } from '../lib/partes';
import { C } from './theme';
import { t } from '../lib/i18n';
import { enviarListaAoPlanner, listaComData, listaNoPlanner } from '../lib/enviarPlanner';
import { listaInteiraPermitida } from '../lib/migrarListas';
import { useDoc } from '../store/store';

/** planner: nas listas de valores ligadas, mostra também "Enviar para o My Planner" / "Tirar do My Planner" (C2). */
export function PartesDaAba({ mod, cor, planner }: { mod: ModId; cor: string; planner?: boolean }) {
  const { visivel } = usePartes(mod);
  const aj = useDoc('ajustes');
  const partes = partesDaAba(mod);
  const cols = DEFS[mod].colecoes;
  return (
    <View style={{ gap: 6 }}>
      {partes.map(c => {
        const on = visivel(c.id);
        const pai = c.pai ? cols.find(x => x.id === c.pai) : null;
        // a última parte visível de uma tela não pode ser desligada
        const ultima = on && partes.filter(x => x.pai === c.pai && visivel(x.id)).length <= 1;
        return (
          <Pressable key={c.id} disabled={ultima} onPress={() => mudarParte(mod, c.id, !on)} style={{ flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 6, opacity: ultima ? 0.6 : 1 }}>
            <Text style={{ fontSize: 20, color: on ? cor : C.mute }}>{on ? '☑' : '☐'}</Text>
            <Text style={{ fontSize: 18 }}>{typeof c.icone === 'string' ? c.icone : '•'}</Text>
            <View style={{ flex: 1 }}>
              <Text style={{ color: C.text, fontWeight: '600' }}>{t(c.nome)}</Text>
              {!!pai && <Text style={{ color: C.sub, fontSize: 11 }}>{t('dentro de {p}', { p: t(pai.um) })}</Text>}
            </View>
            {planner && on && listaComData(c) && !c.semEnviarLista && listaInteiraPermitida(mod, c.id) && (() => {
              const enviada = listaNoPlanner(aj, mod, c.id);
              return (
                <Pressable onPress={() => enviarListaAoPlanner(mod, c.id, !enviada)} hitSlop={6}
                  style={{ paddingVertical: 5, paddingHorizontal: 8, borderRadius: 8, borderWidth: 1, borderColor: cor, backgroundColor: enviada ? 'transparent' : cor, maxWidth: 150 }}>
                  <Text style={{ color: enviada ? cor : '#fff', fontSize: 11, fontWeight: '700', textAlign: 'center' }}>📅 {enviada ? t('Tirar do My Planner') : t('Enviar para o My Planner')}</Text>
                </Pressable>
              );
            })()}
          </Pressable>
        );
      })}
    </View>
  );
}
